import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';

@Component({
  selector: 'app-request-menu',
  templateUrl: './request-menu.component.html',
  styleUrls: ['./request-menu.component.css']
})
export class RequestMenuComponent implements OnInit {

  constructor(private http: HttpClient, private System: TSFuntionService) { }
  public _MenuR_I2PI = [];
  public _MenuR_B2CI = [];
  public _MenuR_B2CP = [];
  public _MenuR_R2R = [];
  ngOnInit() {
    this.GetMenuRequest();
  }

  GetMenuRequest() {
    this.System.BlockUI();
    this.http.get<any>("api/_Menu/GetMenuRequest").subscribe(res => {
      if (res) {
        this._MenuR_I2PI = res.filter(f => f.sGroup === 'I2PI');
        this._MenuR_B2CI = res.filter(f => f.sGroup === 'B2CI');
        this._MenuR_B2CP = res.filter(f => f.sGroup === 'B2CP');
        this._MenuR_R2R = res.filter(f => f.sGroup === 'R2R');
      }
      this.System.UnBlockUI();
    });
  }

}

interface _TM_Menu {
  nMenuId: number;
  nMenuHeadId: number;
  sMenuName: string;
  sIcon: string;
  sClass: string;
  nLevel: string;
  sType: string;
  sUrl: string;
  isOpenFile: boolean;
  isActive: boolean;
  isShow: boolean;
  nOrder: number;
}
